// Lead timeline activity log.
// type: ai_conversation, verification, showing_booked, showing_completed,
//       agent_call, agent_note, status_change, enrichment, assignment,
//       sms_alert, reminder, followup

import { daysAgo, hoursAgo, minutesAgo, hoursAhead } from './leads.js';

let _seq = 0;
const id = (prefix) => `${prefix}-${String(++_seq).padStart(3, '0')}`;

export const activities = [
  // ── Sofia Martinez timeline ──────────────────────────────────────────────
  {
    id: id('act'),
    leadId: 'lead-sofia-martinez',
    agentId: null,
    type: 'ai_conversation',
    description: 'Discovery chat on webchat (Spanish). Confirmed cash $5-6M, Coral Gables.',
    metadata: { conversationId: 'conv-sofia-01' },
    createdAt: hoursAgo(22),
  },
  {
    id: id('act'),
    leadId: 'lead-sofia-martinez',
    agentId: null,
    type: 'enrichment',
    description: 'Real-time verification data confirmed Baptist Health employment (9 years).',
    metadata: { source: 'apollo' },
    createdAt: hoursAgo(22),
  },
  {
    id: id('act'),
    leadId: 'lead-sofia-martinez',
    agentId: null,
    type: 'verification',
    description: 'Verification scorecard 91 · passed. All seven dimensions verified.',
    metadata: { score: 91, status: 'passed' },
    createdAt: hoursAgo(21),
  },
  {
    id: id('act'),
    leadId: 'lead-sofia-martinez',
    agentId: 'agent-natalia-ortiz',
    type: 'assignment',
    description: 'Assigned to Natalia Ortiz (Coral Gables specialist).',
    metadata: {},
    createdAt: hoursAgo(21),
  },
  {
    id: id('act'),
    leadId: 'lead-sofia-martinez',
    agentId: 'agent-natalia-ortiz',
    type: 'agent_call',
    description: 'Intro call · 22 min. Confirmed POF, discussed must-haves.',
    metadata: { durationMinutes: 22, outcome: 'positive' },
    createdAt: hoursAgo(20),
  },
  {
    id: id('act'),
    leadId: 'lead-sofia-martinez',
    agentId: 'agent-natalia-ortiz',
    type: 'showing_booked',
    description: 'Showings booked: 1200 Anastasia Ave and 3541 Main Hwy.',
    metadata: { showingIds: ['showing-07', 'showing-08'] },
    createdAt: hoursAgo(12),
  },
  {
    id: id('act'),
    leadId: 'lead-sofia-martinez',
    agentId: null,
    type: 'status_change',
    description: 'Status changed: qualifying → verified.',
    metadata: { from: 'qualifying', to: 'verified' },
    createdAt: hoursAgo(8),
  },
  {
    id: id('act'),
    leadId: 'lead-sofia-martinez',
    agentId: 'agent-natalia-ortiz',
    type: 'agent_note',
    description: 'Husband cleared schedule for today\u2019s showings.',
    metadata: {},
    createdAt: hoursAgo(3),
  },

  // ── James Chen timeline ──────────────────────────────────────────────────
  {
    id: id('act'),
    leadId: 'lead-james-chen',
    agentId: null,
    type: 'ai_conversation',
    description: 'Discovery webchat. SF relocation, $6-9.5M budget, JPMorgan pre-approval.',
    metadata: { conversationId: 'conv-james-01' },
    createdAt: hoursAgo(14),
  },
  {
    id: id('act'),
    leadId: 'lead-james-chen',
    agentId: null,
    type: 'enrichment',
    description: 'Real-time verification data: VP Engineering at Lumen Capital (NYSE: LMCP).',
    metadata: { source: 'apollo' },
    createdAt: hoursAgo(14),
  },
  {
    id: id('act'),
    leadId: 'lead-james-chen',
    agentId: null,
    type: 'verification',
    description: 'Verification scorecard 88 · passed.',
    metadata: { score: 88, status: 'passed' },
    createdAt: hoursAgo(13),
  },
  {
    id: id('act'),
    leadId: 'lead-james-chen',
    agentId: 'agent-ana-castillo',
    type: 'assignment',
    description: 'Assigned to Ana Castillo (new construction / relo).',
    metadata: {},
    createdAt: hoursAgo(13),
  },
  {
    id: id('act'),
    leadId: 'lead-james-chen',
    agentId: 'agent-ana-castillo',
    type: 'agent_call',
    description: 'Zoom · 30 min. Walked through Mandarin Oriental and St. Regis floor plans.',
    metadata: { durationMinutes: 30 },
    createdAt: hoursAgo(12),
  },
  {
    id: id('act'),
    leadId: 'lead-james-chen',
    agentId: 'agent-ana-castillo',
    type: 'showing_booked',
    description: 'Mandarin Oriental sales gallery tour scheduled.',
    metadata: { showingIds: ['showing-09'] },
    createdAt: hoursAgo(9),
  },
  {
    id: id('act'),
    leadId: 'lead-james-chen',
    agentId: 'agent-ana-castillo',
    type: 'followup',
    description: 'Awaiting James to confirm exact arrival date.',
    metadata: {},
    createdAt: hoursAgo(4),
  },

  // ── Patricia Dubois timeline ─────────────────────────────────────────────
  {
    id: id('act'),
    leadId: 'lead-patricia-dubois',
    agentId: null,
    type: 'ai_conversation',
    description: 'WhatsApp intake. $15-20M cash, waterfront, three-day tour.',
    metadata: { conversationId: 'conv-patricia-01' },
    createdAt: hoursAgo(7),
  },
  {
    id: id('act'),
    leadId: 'lead-patricia-dubois',
    agentId: null,
    type: 'enrichment',
    description: 'HSBC Private bank attestation $40M+ liquid.',
    metadata: { source: 'bank_attestation' },
    createdAt: hoursAgo(7),
  },
  {
    id: id('act'),
    leadId: 'lead-patricia-dubois',
    agentId: null,
    type: 'verification',
    description: 'Verification scorecard 92 · passed. FIRPTA flagged for closing.',
    metadata: { score: 92, status: 'passed' },
    createdAt: hoursAgo(6),
  },
  {
    id: id('act'),
    leadId: 'lead-patricia-dubois',
    agentId: 'agent-marco-rivera',
    type: 'assignment',
    description: 'Escalated to Marco Rivera (ultra-luxury waterfront).',
    metadata: {},
    createdAt: hoursAgo(6),
  },
  {
    id: id('act'),
    leadId: 'lead-patricia-dubois',
    agentId: 'agent-marco-rivera',
    type: 'agent_note',
    description: 'Private driver booked; Faena concierge coordinating meet-ups.',
    metadata: {},
    createdAt: hoursAgo(5),
  },
  {
    id: id('act'),
    leadId: 'lead-patricia-dubois',
    agentId: 'agent-marco-rivera',
    type: 'showing_booked',
    description: 'Three-property tour scheduled for next week.',
    metadata: { showingIds: ['showing-04', 'showing-05', 'showing-06'] },
    createdAt: hoursAgo(4),
  },
  {
    id: id('act'),
    leadId: 'lead-patricia-dubois',
    agentId: null,
    type: 'reminder',
    description: 'Send pre-tour dossier one week before arrival.',
    metadata: { dueAt: hoursAhead(120) },
    createdAt: hoursAgo(2),
  },

  // ── Carlos Mendez timeline ───────────────────────────────────────────────
  {
    id: id('act'),
    leadId: 'lead-carlos-mendez',
    agentId: null,
    type: 'ai_conversation',
    description: 'SMS intake in Spanish. Brickell focus, cash $4-5.5M.',
    metadata: { conversationId: 'conv-carlos-01' },
    createdAt: hoursAgo(2),
  },
  {
    id: id('act'),
    leadId: 'lead-carlos-mendez',
    agentId: null,
    type: 'enrichment',
    description: 'Citibanamex POF letter verified $6M liquid USD.',
    metadata: { source: 'pof' },
    createdAt: minutesAgo(115),
  },
  {
    id: id('act'),
    leadId: 'lead-carlos-mendez',
    agentId: null,
    type: 'verification',
    description: 'Verification scorecard 85 · passed.',
    metadata: { score: 85, status: 'passed' },
    createdAt: minutesAgo(100),
  },
  {
    id: id('act'),
    leadId: 'lead-carlos-mendez',
    agentId: 'agent-diego-herrera',
    type: 'assignment',
    description: 'Assigned to Diego Herrera (Brickell specialist).',
    metadata: {},
    createdAt: minutesAgo(95),
  },
  {
    id: id('act'),
    leadId: 'lead-carlos-mendez',
    agentId: 'agent-diego-herrera',
    type: 'showing_booked',
    description: 'Same-day Brickell tour: Cipriani, Casa Bella, 1000 Biscayne.',
    metadata: { showingIds: ['showing-01', 'showing-02', 'showing-03'] },
    createdAt: minutesAgo(80),
  },
  {
    id: id('act'),
    leadId: 'lead-carlos-mendez',
    agentId: null,
    type: 'sms_alert',
    description: 'SMS confirmation ping delivered.',
    metadata: { channel: 'sms' },
    createdAt: minutesAgo(60),
  },
  {
    id: id('act'),
    leadId: 'lead-carlos-mendez',
    agentId: 'agent-diego-herrera',
    type: 'status_change',
    description: 'Status changed: qualified → showing.',
    metadata: { from: 'qualified', to: 'showing' },
    createdAt: minutesAgo(45),
  },

  // ── Maria Lopez timeline ─────────────────────────────────────────────────
  {
    id: id('act'),
    leadId: 'lead-maria-lopez',
    agentId: null,
    type: 'ai_conversation',
    description: 'SMS nurture (Spanish). Contingent on Doral home sale.',
    metadata: { conversationId: 'conv-maria-01' },
    createdAt: daysAgo(14),
  },
  {
    id: id('act'),
    leadId: 'lead-maria-lopez',
    agentId: null,
    type: 'verification',
    description: 'Verification scorecard 72 · passed. Lender intro needed.',
    metadata: { score: 72, status: 'passed' },
    createdAt: daysAgo(14),
  },
  {
    id: id('act'),
    leadId: 'lead-maria-lopez',
    agentId: 'agent-ana-castillo',
    type: 'assignment',
    description: 'Assigned to Ana Castillo.',
    metadata: {},
    createdAt: daysAgo(14),
  },
  {
    id: id('act'),
    leadId: 'lead-maria-lopez',
    agentId: null,
    type: 'followup',
    description: 'Two-week nurture check-in sent.',
    metadata: {},
    createdAt: daysAgo(1),
  },

  // ── David Rodriguez timeline ─────────────────────────────────────────────
  {
    id: id('act'),
    leadId: 'lead-david-rodriguez',
    agentId: 'agent-marco-rivera',
    type: 'assignment',
    description: 'Referral from existing client. Assigned to Marco Rivera.',
    metadata: {},
    createdAt: daysAgo(21),
  },
  {
    id: id('act'),
    leadId: 'lead-david-rodriguez',
    agentId: null,
    type: 'verification',
    description: 'Verification scorecard 78 · passed.',
    metadata: { score: 78, status: 'passed' },
    createdAt: daysAgo(21),
  },
  {
    id: id('act'),
    leadId: 'lead-david-rodriguez',
    agentId: 'agent-marco-rivera',
    type: 'showing_completed',
    description: 'Second visit at 1200 Anastasia with partner. Positive.',
    metadata: { showingId: 'showing-10' },
    createdAt: daysAgo(2),
  },
  {
    id: id('act'),
    leadId: 'lead-david-rodriguez',
    agentId: 'agent-marco-rivera',
    type: 'agent_note',
    description: 'Prepping HOA breakdown and neighborhood comps packet.',
    metadata: {},
    createdAt: daysAgo(2),
  },

  // ── Emily Watson timeline (escalation) ───────────────────────────────────
  {
    id: id('act'),
    leadId: 'lead-emily-watson',
    agentId: null,
    type: 'ai_conversation',
    description: 'Webchat · AI handled schools question, escalated on pricing.',
    metadata: { conversationId: 'conv-emily-01', escalated: true },
    createdAt: daysAgo(3),
  },
  {
    id: id('act'),
    leadId: 'lead-emily-watson',
    agentId: 'agent-natalia-ortiz',
    type: 'assignment',
    description: 'Auto-escalation to Natalia Ortiz (Grove specialist).',
    metadata: { reason: 'price_negotiation' },
    createdAt: daysAgo(3),
  },
  {
    id: id('act'),
    leadId: 'lead-emily-watson',
    agentId: 'agent-natalia-ortiz',
    type: 'agent_call',
    description: '4pm call · comps and HOA reviewed. No offer yet.',
    metadata: { durationMinutes: 18 },
    createdAt: daysAgo(3),
  },
  {
    id: id('act'),
    leadId: 'lead-emily-watson',
    agentId: null,
    type: 'reminder',
    description: 'Follow up in 72 hours if no response.',
    metadata: {},
    createdAt: daysAgo(3),
  },

  // ── Roberto Silva timeline ───────────────────────────────────────────────
  {
    id: id('act'),
    leadId: 'lead-roberto-silva',
    agentId: null,
    type: 'ai_conversation',
    description: 'WhatsApp intake in Portuguese. Investment + partial use.',
    metadata: { conversationId: 'conv-roberto-01' },
    createdAt: daysAgo(27),
  },
  {
    id: id('act'),
    leadId: 'lead-roberto-silva',
    agentId: null,
    type: 'verification',
    description: 'Verification scorecard 74 · passed.',
    metadata: { score: 74, status: 'passed' },
    createdAt: daysAgo(27),
  },
  {
    id: id('act'),
    leadId: 'lead-roberto-silva',
    agentId: 'agent-diego-herrera',
    type: 'assignment',
    description: 'Assigned to Diego Herrera.',
    metadata: {},
    createdAt: daysAgo(27),
  },
  {
    id: id('act'),
    leadId: 'lead-roberto-silva',
    agentId: null,
    type: 'followup',
    description: 'AI follow-up sent after 3 weeks. Virtual tour proposed.',
    metadata: {},
    createdAt: daysAgo(4),
  },

  // ── Nurture / long-horizon timelines ─────────────────────────────────────
  {
    id: id('act'),
    leadId: 'lead-sarah-williams',
    agentId: null,
    type: 'verification',
    description: 'Verification scorecard 52 · pending (lender not engaged).',
    metadata: { score: 52, status: 'pending' },
    createdAt: daysAgo(62),
  },
  {
    id: id('act'),
    leadId: 'lead-sarah-williams',
    agentId: 'agent-ana-castillo',
    type: 'assignment',
    description: 'Assigned to Ana Castillo for nurture cadence.',
    metadata: {},
    createdAt: daysAgo(62),
  },
  {
    id: id('act'),
    leadId: 'lead-sarah-williams',
    agentId: null,
    type: 'followup',
    description: 'Monthly market report sent.',
    metadata: {},
    createdAt: daysAgo(11),
  },
  {
    id: id('act'),
    leadId: 'lead-michael-park',
    agentId: null,
    type: 'verification',
    description: 'Verification scorecard 48 · budget flagged.',
    metadata: { score: 48, status: 'pending' },
    createdAt: daysAgo(48),
  },
  {
    id: id('act'),
    leadId: 'lead-michael-park',
    agentId: 'agent-diego-herrera',
    type: 'assignment',
    description: 'Assigned to Diego Herrera.',
    metadata: {},
    createdAt: daysAgo(48),
  },
  {
    id: id('act'),
    leadId: 'lead-michael-park',
    agentId: null,
    type: 'followup',
    description: 'Inventory-reality email sent.',
    metadata: {},
    createdAt: daysAgo(14),
  },
  {
    id: id('act'),
    leadId: 'lead-ana-garcia',
    agentId: 'agent-natalia-ortiz',
    type: 'assignment',
    description: 'Assigned to Natalia Ortiz for long-horizon nurture.',
    metadata: {},
    createdAt: daysAgo(70),
  },
  {
    id: id('act'),
    leadId: 'lead-ana-garcia',
    agentId: null,
    type: 'followup',
    description: 'Quarterly reactivation touch.',
    metadata: {},
    createdAt: daysAgo(22),
  },
  {
    id: id('act'),
    leadId: 'lead-thomas-brown',
    agentId: 'agent-marco-rivera',
    type: 'assignment',
    description: 'Assigned to Marco Rivera (second-home Boston PE).',
    metadata: {},
    createdAt: daysAgo(55),
  },
  {
    id: id('act'),
    leadId: 'lead-thomas-brown',
    agentId: null,
    type: 'followup',
    description: 'Curated Key Biscayne + Grove listings email.',
    metadata: {},
    createdAt: daysAgo(9),
  },

  // ── Cold / Dead ──────────────────────────────────────────────────────────
  {
    id: id('act'),
    leadId: 'lead-richard-smith',
    agentId: null,
    type: 'followup',
    description: 'Third attempt via SMS, no response.',
    metadata: { attempt: 3 },
    createdAt: daysAgo(30),
  },
  {
    id: id('act'),
    leadId: 'lead-jennifer-davis',
    agentId: null,
    type: 'status_change',
    description: 'Explicit opt-out received. Marked dead.',
    metadata: { from: 'nurture', to: 'dead' },
    createdAt: daysAgo(70),
  },
  {
    id: id('act'),
    leadId: 'lead-kevin-hughes',
    agentId: null,
    type: 'followup',
    description: 'Out-of-territory referral offered; no response.',
    metadata: {},
    createdAt: daysAgo(28),
  },

  // ── Alexander Volkov (RED FLAG) ──────────────────────────────────────────
  {
    id: id('act'),
    leadId: 'lead-alexander-volkov',
    agentId: null,
    type: 'ai_conversation',
    description: 'Webchat intake. Claims $8.5M cash, urgent Moscow relocation.',
    metadata: { conversationId: 'conv-volkov-01' },
    createdAt: daysAgo(3),
  },
  {
    id: id('act'),
    leadId: 'lead-alexander-volkov',
    agentId: null,
    type: 'enrichment',
    description: 'Verification + public records: no employer found, no public profile, no property records.',
    metadata: { source: 'apollo+osint', result: 'no_matches' },
    createdAt: daysAgo(3),
  },
  {
    id: id('act'),
    leadId: 'lead-alexander-volkov',
    agentId: null,
    type: 'verification',
    description: 'Verification 42 · flagged. 5 severe inconsistencies.',
    metadata: { score: 42, status: 'flagged' },
    createdAt: daysAgo(3),
  },
  {
    id: id('act'),
    leadId: 'lead-alexander-volkov',
    agentId: null,
    type: 'sms_alert',
    description: 'Team alert: Red flag lead needs manual review before any outreach.',
    metadata: { severity: 'high', channel: 'internal' },
    createdAt: hoursAgo(12),
  },
  {
    id: id('act'),
    leadId: 'lead-alexander-volkov',
    agentId: null,
    type: 'agent_note',
    description: 'Auto-paused. Awaiting compliance review and OFAC/sanctions screening.',
    metadata: {},
    createdAt: hoursAgo(12),
  },

  // ── Disqualified ─────────────────────────────────────────────────────────
  {
    id: id('act'),
    leadId: 'lead-frank-reed',
    agentId: null,
    type: 'verification',
    description: 'Verification 18 · failed. Budget below minimum.',
    metadata: { score: 18, status: 'failed' },
    createdAt: daysAgo(24),
  },
  {
    id: id('act'),
    leadId: 'lead-frank-reed',
    agentId: null,
    type: 'status_change',
    description: 'Disqualified at intake. Referral sent to partner brokerage.',
    metadata: { from: 'qualifying', to: 'disqualified' },
    createdAt: daysAgo(24),
  },
  {
    id: id('act'),
    leadId: 'lead-linda-brooks',
    agentId: null,
    type: 'verification',
    description: 'Verification 22 · failed. Budget below minimum.',
    metadata: { score: 22, status: 'failed' },
    createdAt: daysAgo(32),
  },
  {
    id: id('act'),
    leadId: 'lead-linda-brooks',
    agentId: null,
    type: 'status_change',
    description: 'Disqualified at intake. Referral sent.',
    metadata: { from: 'qualifying', to: 'disqualified' },
    createdAt: daysAgo(32),
  },
];

// Keep helper references from tree-shaking warnings.
void hoursAhead;

// Sort newest first.
activities.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

export const activitiesByLeadId = activities.reduce((acc, a) => {
  (acc[a.leadId] = acc[a.leadId] || []).push(a);
  return acc;
}, {});
